<template>
    <AdaptersDialog
        :listener-id="getListenerIdOpen"
        :listener-close-id="getListenerIdClose"
        :header="$t('lang.main.common.telegramConnect.title')"
        :callback-on-show="onOpen"
        :callback-on-hide="onHide"
        :error-message="error"
        :loading="loading"
        append-to="body"
    >
        <template #content>
            <div class="grid" v-if="link">
                <div class="col-12">
                    <p v-html="$t('lang.main.common.telegramConnect.text', [getConnectLink])" />
                </div>
                <div class="col-12">
                    <div class="flex justify-content-center">
                        <vue-qrcode :value="link" :options="{ width: 300 }"></vue-qrcode>
                    </div>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
import AdaptersDialog from "../adapters/Dialog.vue";
import {Listeners} from "../../constants/listeners";
import UserApi from "../../api/UserApi";
import Alerts from "../../mixins/Alerts";
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    name: "TelegramConnect",
    mixins: [Alerts],
    data() {
        return {
            error: null,
            link: null,
            loading: false,
            uid: null,
            timer: null,
        };
    },
    mounted() {
        this.$emitter.on(this.getListenerIdOpen, (uid) => {
            /**
             * uid необходим для определения конкретного места вызова (для передачи слушателю Listeners.USER_TELEGRAM_CONNECTED)
             * Например, в оповещениях при подключении ТГ в определенном проекте опция сама включается
             */
            this.uid = uid;
        });
    },
    computed: {
        getListenerIdOpen() {
            return Listeners.POPUP_TELEGRAM_CONNECT_OPEN;
        },
        getListenerIdClose() {
            return Listeners.POPUP_TELEGRAM_CONNECT_CLOSE;
        },
        getConnectLink() {
            return this.link;
        },
    },
    methods: {
        onOpen() {
            if (this.link) {
                // уже ссылка была подгружена
                this.checkConnected();
                return;
            }

            this.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);
            UserApi
                .getLinkTelegramConnect()
                .then(response => {
                    this.link = response.link;
                    this.checkConnected();
                })
                .catch(error => this.alertError(error))
                .finally(() => this.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE));
        },
        onHide() {
            clearTimeout(this.timer);
        },
        checkConnected() {
            UserApi
                .isTelegramConnected()
                .then(response => {
                    if (response.code === 202) {
                        this.timer = setTimeout(() => {
                            this.checkConnected();
                        }, 2000);
                    } else {
                        this.$emitter.emit(Listeners.USER_TELEGRAM_CONNECTED, this.uid);
                        this.$emitter.emit(this.getListenerIdClose);
                    }
                })
                .catch(error => this.alertError(error));
        },
    },
    components: {
        AdaptersDialog,
        VueQrcode,
    }
}
</script>
